require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.symbol.observable.js
// module id = 1383
// module chunks = 114